/**
 * Legacy NavApp rows that duplicate or should not be used for tenant app scoping.
 * - OEE: old code; production/OEE module is OEE_PRODUCTION only.
 * - OVERVIEW: not a licensable app (home / workspace overview is always available).
 */

export function isLegacyNavAppHiddenFromTenantScope(code) {
  const c = String(code || "").toUpperCase();
  return c === "OEE" || c === "OVERVIEW";
}

/** Normalize stored tenant app codes when loading admin UI (merge OEE → OEE_PRODUCTION, drop OVERVIEW). */
export function normalizeTenantNavAppCodes(codes) {
  if (!Array.isArray(codes) || codes.length === 0) return [];
  const seen = new Set();
  const out = [];
  for (const raw of codes) {
    if (raw == null || String(raw).trim() === "") continue;
    let c = String(raw).trim();
    const u = c.toUpperCase();
    if (u === "OVERVIEW") continue;
    if (u === "OEE") c = "OEE_PRODUCTION";
    const key = c.toUpperCase();
    if (!seen.has(key)) {
      seen.add(key);
      out.push(c);
    }
  }
  return out;
}
